import React from 'react';
import { motion } from 'framer-motion';
export function FinalReflection() {
  const lines = [{
    text: "Quizás llegaste hasta esta página porque estabas buscando algo más que un libro"
  }, {
    text: 'Algo más que una rutina de 30 días.'
  }, {
    text: 'Algo más que información.'
  }, {
    text: 'Tal vez estabas buscando volver a sentir esa paz que hace tiempo no experimentas.'
  }, {
    text: 'Volver a confiar cuando las circunstancias parecen difíciles.'
  }, {
    text: 'Volver a escuchar la voz de Dios en medio del ruido, las preocupaciones y la incertidumbre.'
  }, {
    text: 'La verdad es que nadie puede recorrer este camino por ti.'
  }, {
    text: 'Pero tampoco tienes que hacerlo sola.',
    emphasis: true
  }, {
    text: 'Durante los próximos 30 días tendrás una oportunidad para detenerte, respirar, renovar tu mente y acercarte nuevamente a Dios de una forma más profunda y consciente.'
  }, {
    text: 'No porque necesites ser una persona perfecta.'
  }, {
    text: 'No porque tengas todas las respuestas.'
  }, {
    text: 'Sino porque Dios sigue obrando en tu vida, incluso en los momentos en que no puedes verlo.'
  }, {
    text: 'Dentro de unos meses mirarás hacia atrás.'
  }, {
    text: 'Y agradecerás haber dado este paso.',
    emphasis: true
  }, {
    text: 'Porque muchas veces las mayores transformaciones comienzan con una simple decisión.'
  }, {
    text: 'Y esa decisión puede comenzar hoy.',
    emphasis: true
  }];
  return <section className="w-full bg-[#0A1535] py-24 px-6 relative overflow-hidden" style={{
    backgroundColor: "#FFFFFF",
    backgroundImage: "none"
  }} data-id="element-90" data-mp="3ngt3nkvjwvsn">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(224,183,86,0.12)_0%,_transparent_70%)]" data-id="element-91" data-mp="3iihulcd2ypbh"></div>

      <div className="relative z-10 max-w-3xl mx-auto text-center" data-id="element-92" data-mp="3dgiq1z5ltmcy">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-4xl font-bold text-[#E0B756] mb-12" style={{
        color: "#E0B756"
      }} data-id="element-93" data-mp="38i8u3mc22hqa">
          Tal vez esta no sea una coincidencia
        </motion.h2>

        <div className="space-y-5 mb-12" data-id="element-94" data-mp="2yx7v9c7hnuh6">
          {lines.map((line, index) => <motion.p key={index} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.05
        }} className={line.emphasis ? 'text-xl text-white font-semibold leading-relaxed' : 'text-lg text-gray-300 leading-relaxed'} style={{
          color: "#C9A24B"
        }} data-id="element-95" data-mp="2kx6sfr7nycz2" data-mpi={index}>
              {line.text}
            </motion.p>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-3 mb-12" data-id="element-96" data-mp="38tasq4reb4xs">
          <p className="text-xl text-white" style={{
          color: "#C9A24B"
        }} data-id="element-97" data-mp="56k9a811vl1o">
            Dios ya está tocando la puerta de tu corazón.
          </p>
          <p className="text-lg text-gray-300" style={{
          color: "#C9A24B"
        }} data-id="element-98" data-mp="ai7mqk6ja5wk">La pregunta es:</p>
          <p className="text-3xl md:text-4xl font-bold text-[#E0B756] pt-2" data-id="element-99" data-mp="o9mdxealhdep">
            ¿Estás lista para abrirla?
          </p>
        </motion.div>

        <motion.a href="https://pay.hotmart.com/A105236382M" target="_blank" rel="noopener noreferrer" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="inline-block bg-gradient-to-r from-[#C9A24B] to-[#E0B756] text-[#0A1535] font-bold text-lg px-10 py-5 rounded-full shadow-lg hover:shadow-2xl transition-shadow focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#E0B756] focus-visible:ring-offset-2 focus-visible:ring-offset-[#0A1535]" style={{
        color: "#FFFFFF"
      }} data-id="element-100" data-mp="jbubhqcbq8w9">
          SÍ, QUIERO COMENZAR MI MÉTODO R.E.V.E.L.A. HOY
        </motion.a>
      </div>
    </section>;
}